export default __webpack_public_path__ + "static/media/gravel4.84f67e81.jpeg";